import { useRef, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { nuevaContrasenaSchema } from '../../validation/nuevaContrasenaValidation';
import { cambiarContrasena } from '../../services/authService';

import logo from "../../assets/logos/TRANSKYRIOS-_IconColor.avif";
import ContactoTI from "../../components/contacto-ti/contacto-ti";
import ModuleLayout from '../../layouts/layout-modulo.js';
import './cambiar-contrasena.css';

import { useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';


function CambiarContrasena() {
  const toast = useRef(null);
  const navigate = useNavigate();
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { handleSubmit, formState: { errors }, control, reset
  } = useForm({
    resolver: yupResolver(nuevaContrasenaSchema),
    mode: 'onTouched', reValidateMode: 'onChange',
  });

  const limpiarForm = () => reset();

  const guardarCambios = async (data) => {
    setIsSubmitting(false);

    const payload = {
      contra_actual: data.contra_actual,
      contra_nueva: data.contra_nueva,
    }

    try {
      const resp = await cambiarContrasena(payload);

      if (resp?.ok === false) {
        throw new Error('No se pudo cambiar la contraseña');
      }
    
      toast.current.show({ 
        severity: 'success', 
        summary: 'Exito', 
        detail: 'Se ha cambiado la contraseña correctamente.'
      });

      limpiarForm();

    } catch (error) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: error || 'Ocurrió un error al cambiar la contraseña. Intente nuevamente.',
        life: 4500
      });
    }
  }

  return (
    <ModuleLayout titulo="Cambiar Contraseña" logo={logo} onVolver={() => navigate('/app')}>
      <Toast ref={toast} position='center'/>
      <section className="tmc-content">
        <section className="form-section">
          <form className="mt-2 container-form">
            <div className='card-nc'>

              <p className='font-semibold text-lg mb-4'>
                Como verificación de seguridad deberá ingresar su contraseña actual, 
                antes de continuar con el cambio.
              </p>

              {/* Contraseña Actual */}
              <div className="form-row-2col mb-4">
                <div>
                  <label className="form-label mb-0">
                    Contraseña Actual<span className="required">*</span>
                  </label>
                </div>

                <div>
                  <Controller
                    name="contra_actual"
                    control={control}
                    render={({ field }) => (
                      <Password
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Ingrese su actual contraseña"
                        invalid={!!errors.contra_actual}
                        toggleMask
                        feedback={false}
                      />
                    )}
                  />
                  {errors.contra_actual && (<div className="invalid-feedback d-block">{errors.contra_actual.message}</div>
                  )}
                </div>
              </div>

              {/* Requisitos nueva contraseña */}
              <div className='note-yellow mb-4'>
                <details open>
                  <summary>Requisitos de nueva contraseña</summary>
                  <ul className='pl-5 pt-2'>
                    <li>Mínimo 10 caracteres.</li>
                    <li>Al menos 1 mayúscula.</li>
                    <li>Al menos 1 minúscula.</li>
                    <li>Al menos 1 número.</li>
                    <li>Al menos 1 carácter especial (!@#$%&*_-+=?).</li>
                    <li>Sin espacios.</li>
                    <li>Sin secuencias (123, abc).</li>
                  </ul>
                </details>
              </div>

              {/* Nueva Contraseña */} 
              <div className="form-row-2col mb-4">
                <div>
                  <label className="form-label mb-0">
                    Nueva Contraseña<span className="required">*</span>
                  </label>
                </div>

                <div>
                  <Controller
                    name="contra_nueva"
                    control={control}
                    render={({ field }) => (
                      <Password 
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Ingrese su nueva contraseña"
                        invalid={!!errors.contra_nueva}
                        toggleMask
                        feedback={false}
                      />
                    )}
                  />
                  {errors.contra_nueva && (<div className="invalid-feedback d-block">{errors.contra_nueva.message}</div>)}
                </div>
              </div>

              {/* Confirmar Contraseña */}
              <div className="form-row-2col mb-4">
                <div>
                  <label className="form-label mb-0">
                    Confirmar Contraseña<span className="required">*</span>
                  </label>
                </div>
                
                <div>
                  <Controller
                    name="contra_confirmar"
                    control={control}
                    render={({ field }) => (
                      <Password
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                        placeholder="Repita su nueva contraseña"
                        invalid={!!errors.contra_confirmar}
                        toggleMask
                        feedback={false}
                      />
                    )}
                  />
                  {errors.contra_confirmar && (<div className="invalid-feedback d-block">{errors.contra_confirmar.message}</div>)}
                </div>
              </div>

              <div className='tmc-btns-container mt-6 mb-2'>
                <Button type="button" label="Guardar Cambios" icon="pi pi-save" 
                  className="inv-btn-confirm"
                  onClick={handleSubmit(guardarCambios)}
                  disabled={isSubmitting}
                />
              </div>
            </div>
          </form>
        </section>
      </section>
      <section className="per-content">
        <ContactoTI />
      </section>
    </ModuleLayout>
  );
}

export default CambiarContrasena